var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8009_5112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26318 9.84036V13.3657H6.44845C6.6299 13.3658 6.80965 13.3315 6.97733 13.265C7.14495 13.1984 7.29735 13.1009 7.42569 12.9779L13.5498 7.10899C13.8094 6.86077 13.9555 6.52394 13.956 6.17246V1.21094H10.2774V8.51453C10.2776 8.68987 10.2415 8.86352 10.1712 9.02537C10.1008 9.18722 9.99767 9.33405 9.86763 9.45741C9.73758 9.58076 9.58323 9.67815 9.41365 9.74388C9.244 9.80961 9.06249 9.84241 8.87952 9.84036H1.26318Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7215 13.1543V9.62891H17.5363C17.3548 9.62891 17.1751 9.6631 17.0075 9.72968C16.8398 9.7962 16.6874 9.89371 16.559 10.0167L10.4349 15.8856C10.3067 16.0086 10.2048 16.1546 10.1354 16.3153C10.066 16.476 10.0303 16.6482 10.0303 16.8222V21.7883H13.7089V14.4786C13.7089 14.3045 13.7447 14.1322 13.8143 13.9714C13.8838 13.8107 13.9857 13.6646 14.1143 13.5416C14.2427 13.4186 14.3952 13.3211 14.5631 13.2546C14.7309 13.1882 14.9108 13.1541 15.0924 13.1543H22.7215Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8009_5112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.8d42df5da6c6fee7e3902d351bcd4803.svg";
export { ForwardRef as ReactComponent };